import { Pet } from '$api-client/types.gen'
import { cn } from '$components'
import { DogIcon } from '$components'
import { Image } from '$components'
import { Tooltip } from '$components'
import { Link } from 'react-router-dom'
import { PetRoutePaths } from '../../pets/routes/protected'
import { Router } from '$utils/router'

export type PetsCellProps = {
  pets: Pet[]
}

export function PetsCell({ pets }: PetsCellProps) {

  return (
    <div className="flex relative z-[2]">
      {pets.map((pet, key) => (
        <Link
          key={key}
          to={Router.getRoute(PetRoutePaths.PetsView, { id: pet.id.toString() })}
          onClick={(e) => e.stopPropagation()}
          className="shrink-0 flex items-center justify-center"
        >
          <Tooltip content={pet.name}>
            <div className={cn(
              'hover:outline rounded-full hover:outline-indigo-500 cursor-pointer',
              {
                '-ml-2.5': key !== 0,
              },
            )}
            >
              <Image
                src={pet.image}
                alt={pet.name}
                fallbackIcon={DogIcon}
              />
            </div>
          </Tooltip>
        </Link>
      ))}
    </div>
  )
}
